import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import storageApi from 'src/api/storage'

export const  getOrFilterProductStockRecord = createAsyncThunk(
     'storage/getOrFilterProductStockRecord',
    async (query) => {
      const response = await storageApi.getOrFilterProductStockRecord(query)
      // console.log('Fetch Product Stock response', response)
      return response
    }
)

export const getProductLowStockList = createAsyncThunk(
  'storage/getProductLowStockList',
 async (query) => {
   const response = await storageApi.getProductLowStockList(query)
  //  console.log('Fetch Alert Product response', response)
   return response
 }
)

const initialState = {
  isModalOpen: false,
  modalViewName: null,
  modalViewParams: null,
  detail: null,
  reload: false,

  status:'',
  lowStockLoadingStatus:'',
  stockList:[],
  lowStockAlert:[],
  loading: true,
  error:'',
}

const slice = createSlice({
  name: 'storageAlert',
  initialState,
  reducers: {
    updateProductStock(oldState, action) {
        let newProduct = action.payload;
        let filteredStorageAlert=[...oldState.stockList].filter((each)=>{
          return each.id!==newProduct.id
        })
        oldState.stockList = [newProduct, ...filteredStorageAlert ]
  
    },

    setProductLowStockList(oldState,action){
      let newAlertList=action.payload;
      oldState.lowStockAlert=newAlertList
    },

    openModal(oldState) {
        oldState.isModalOpen = true
      },
  
      closeModal(oldState) {
        oldState.isModalOpen = false
        oldState.modalViewName = null
        oldState.modalViewParams = null
      },
  
      setModalViewName(oldState, action) {
        oldState.modalViewName = action.payload
      },
  
      setModalViewParams(oldState, action) {
        oldState.modalViewParams = action.payload
      },
      setReload(oldState, action) {
        oldState.reload = action.payload
      },
    
  },
  extraReducers: {
    [getOrFilterProductStockRecord.pending]: (state, action) => {
        state.status = 'loading'
        state.loading = true
    },
    [getOrFilterProductStockRecord.fulfilled]: (state, action) => {
        state.status = 'succeeded'
        state.stockList = action.payload.content
        state.loading = false;
    },
    [getOrFilterProductStockRecord.rejected]: (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
    },

    [getProductLowStockList.pending]: (state, action) => {
      state.lowStockLoadingStatus = 'loading'
      state.loading = true
    },
    [getProductLowStockList.fulfilled]: (state, action) => {
      state.lowStockLoadingStatus = 'succeeded'
      state.lowStockAlert = action.payload.content
      state.loading = false;
    },
    [getProductLowStockList.rejected]: (state, action) => {
      state.lowStockLoadingStatus = 'failed'
      state.error = action.error.message
  }
}

})

export const reducer = slice.reducer

/* Modal */
export const setModalViewName = (viewName) => (dispatch) => {
    dispatch(slice.actions.setModalViewName(viewName))
  }
  
  export const setModalViewParams = (params) => (dispatch) => {
    dispatch(slice.actions.setModalViewParams(params))
  }
  
  export const openModal = () => (dispatch) => {
    dispatch(slice.actions.openModal())
  }
  
  export const closeModal = () => (dispatch) => {
    dispatch(slice.actions.closeModal())
  }
  
  export const setReload = (reload) => (dispatch) => {
    dispatch(slice.actions.setReload(reload))
  }

  //Update Product Stock
  export const updateProductStock= (requestBody) => async (dispatch) => {
    const result = await storageApi.updateProductStock(requestBody)
    // console.log('dispatch result', result)
    dispatch(slice.actions.updateProductStock(result))
  }


export default slice
